import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Check, Sparkles } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { loadSynergies } from "../lib/synergies";
import { loadProducts } from "./ResearchStacks";
import ProductImage from "./ProductImage";

function SynergyCard({ product, reason }) {
  const { addItem } = useCart();
  const [added, setAdded] = useState(false);
  const v = product.variants[0];
  const add = () => { addItem(product, v, 1); setAdded(true); setTimeout(() => setAdded(false), 2200); };

  return (
    <div data-testid={`synergy-card-${product.slug}`} className="bg-[#0C0C12] p-4 flex items-center gap-4">
      <Link to={`/product/${product.slug}`} className="w-16 h-16 vial-bg flex items-center justify-center shrink-0">
        <ProductImage product={product} className="w-[80%] h-[85%]" />
      </Link>
      <div className="flex-1 min-w-0">
        <Link to={`/product/${product.slug}`} className="font-heading text-base text-white hover:text-[#00C3FF] transition-colors block truncate">{product.name}</Link>
        <div className="text-[11px] text-[#8A94A6] mt-0.5 truncate">{reason}</div>
        <div className="font-mono-tech text-xs text-[#00C3FF] mt-1">${Number(v.price).toFixed(2)} · {v.size}</div>
      </div>
      <button data-testid={`synergy-add-${product.slug}`} onClick={add} disabled={added} className="btn-ghost shrink-0" style={{ padding: "10px 14px" }}>
        {added ? <Check size={14} /> : <Plus size={14} />}
      </button>
    </div>
  );
}

// "Complementary Compounds" on every PDP, from the curated synergy map.
export default function SynergyRecommendations({ product }) {
  const [map, setMap] = useState({});
  const [all, setAll] = useState([]);
  useEffect(() => { loadSynergies().then(setMap); loadProducts().then(setAll); }, []);
  const bySlug = Object.fromEntries(all.map((p) => [p.slug, p]));
  const recs = (map[product.slug] || []).map((r) => ({ ...r, product: bySlug[r.slug] })).filter((r) => r.product?.variants?.length);
  if (!recs.length) return null;

  return (
    <section data-testid="synergy-recommendations" className="mt-16">
      <div className="overline flex items-center gap-2"><Sparkles size={12} /> COMPLEMENTARY COMPOUNDS</div>
      <h2 className="font-heading text-2xl sm:text-3xl mt-3 mb-6">Commonly researched alongside {product.name}.</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
        {recs.map((r) => <SynergyCard key={r.slug} product={r.product} reason={r.reason} />)}
      </div>
    </section>
  );
}
